"use client"
import React from "react"
import Navbar from "../../components/agent/common/Navbar"
import CampaignBuilder from "../../components/agent/marketing/CampaignBuilder"

const AgentMarketingCampaignBuilder = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
        <CampaignBuilder />
      </main>
    </div>
  )
}

export default AgentMarketingCampaignBuilder